import React, { useEffect } from 'react';
import CommonModal from '../../common/Modal';
import './index.scss';
import RxCardSendCoupon from '../../RxCard/RxCardSendCoupon';
import SocialApps from '../../SocialApps';
import { object, func } from 'prop-types';

const RequestReceiveModal = ({
  t,
  language,
  closeRequestModal,
  triggerGTMEvents,
  selectedPrice
}) => {
  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = 'hidden';
    }, 10);
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  return (
    <div className="requestReceiveWrapper">
      <CommonModal
        closeDialogHandler={closeRequestModal}
        closeButtonIMG="icon-close-white.svg"
      >
        <div className="requestReceiveContent">
          <p className="title">{t('Request received!')}</p>
          <div className="description">
            <p className="descTitle">
              {t('Your SingleCare card is on its way!')}
            </p>
            <p className="noteText">{t('It should arrive within 4 weeks.')}</p>
            <p className="noteText">
              {t(
                'If you need a card sooner, you can print or send yourself a digital card'
              )}
              :
            </p>
          </div>
          <RxCardSendCoupon
            triggerGTMEvents={triggerGTMEvents}
            selectedPrice={selectedPrice}
            isFromPhysicalModal={true}
            isFromDiscountPage={false}
            isRxCard={true}
          />
          <div className="desktop-only">
            <div className="appPromoDesktop">
              <p>{t('Keep your coupons handy with the free SingleCare app')}</p>
              <div className="flyerWrapper">
                <SocialApps
                  isApps={true}
                  isLandingPages={true}
                  labelText={' '}
                  buttonText={t('Send link to app')}
                  type={'mobileApps'}
                />
                <div>
                  <a
                    href="https://singlecare.onelink.me/OxIQ/f9jc9woy"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="SingleCare iOS App"
                  >
                    <img
                      src={`/content/images/footer/appStore-white${
                        language === 'es' ? '-spanish' : ''
                      }.svg`}
                      alt={t('App Store footer')}
                    />
                  </a>
                  <a
                    href="https://singlecare.onelink.me/OxIQ/72dmiyj0"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="SingleCare Android App"
                  >
                    <img
                      src={`/content/images/footer/google-play-white${
                        language === 'es' ? '-spanish' : ''
                      }.svg`}
                      alt={t('Google play badge spanish')}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          {language === 'es' && <div className="esPadding" />}
          <div className="appMobileContainer mobile-only">
            <div className="mobileAppsBanner">
              <div className="iconWrap">
                <img src="/content/images/icons/singlecare icon.svg" alt="" />
              </div>
              <p>{t('Switch to the free app.')}</p>
              <a
                href="https://singlecare.onelink.me/OxIQ/c8fe6bf"
                target="_blank"
                rel="noreferrer"
                aria-label="SingleCare iOS App"
              >
                {t('Install now')}
              </a>
            </div>
          </div>
        </div>
      </CommonModal>
    </div>
  );
};
RequestReceiveModal.prototype = {
  closeRequestModal: func,
  triggerGTMEvents: func,
  selectedPrice: object
};
RequestReceiveModal.defaultProps = {
  closeRequestModal: () => {},
  triggerGTMEvents: () => {},
  selectedPrice: { PBAClientName: '', PartnerPassword: '' }
};
export default RequestReceiveModal;
